import {Pipe, PipeTransform} from '@angular/core';
import {KeyValue} from '@angular/common';
import {getTcoKeyMapping, UnitlessMappingValue} from '../models/mappingUtils';

@Pipe({
  name: 'tcoValues'
})
export class TcoValuesPipe implements PipeTransform {

  transform(value: Array<KeyValue<any, any>>, ...args: unknown[]): Array<KeyValue<string, {mapping: UnitlessMappingValue, value: number}>> {
    return value.filter(({value: val}) => typeof val === 'number').map(({key, value: val}) => {
      const tcoKeyMapping = getTcoKeyMapping(key);
      return {key, value: {mapping: tcoKeyMapping, value: val}};
    });
  }

}
